import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { style } from 'typestyle';
import * as styles from '../../offices/offices.styles';
import FacilityTypeCard from '../cards/facility-type-card.component';
import { FacilityTypeEnum, getFacilityTypeFromString } from '../enums/facility-type';
import FacilityType from '../models/facility-type';
import Column from '../../../core/components/column/column.component';
import { CrossAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';
import { IsMobileContext } from '../../../core/context/is-mobile';
import Grid from '../../../core/components/grid/grid.component';

interface Props {
  readonly initiallySelectedFacilityType: FacilityTypeEnum;
  readonly handleFacilityTypeSelectionChanged: (value: FacilityType) => void;
}

const FacilityTypesGroup = ({ initiallySelectedFacilityType, handleFacilityTypeSelectionChanged }: Props): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();
  const [selectedFacilityType, setSelectedFacilityType] = useState<FacilityType>();
  const [didFillData, setDidFillData] = useState(false);
  const allfacilityTypes = Object.keys(FacilityTypeEnum)
    .filter((item) => Number.isNaN(Number(item)))
    .map((item: string) => {
      const facilityType = new FacilityType(getFacilityTypeFromString(item));
      facilityType.translatedType = t(`enums.facility-type-enum.${item}`);
      return facilityType;
    });

  const sortedFacilityTypes = allfacilityTypes.sort((a, b) => (a.translatedType.toLowerCase() > b.translatedType.toLowerCase() ? 1 : -1));

  const handleFacilityTypeChanged = (selected: FacilityType): void => {
    setSelectedFacilityType(selected);
    handleFacilityTypeSelectionChanged(selected);
  };

  if (allfacilityTypes && !didFillData) {
    setSelectedFacilityType(new FacilityType(initiallySelectedFacilityType));
    setDidFillData(true);
  }

  return (
    <div className={style(styles.inModalSectionCard(isMobile))}>
      <Column className={style(styles.headerMargin)}>
        <Row crossAxisAlignment={CrossAxisAlignment.Center}>
          <span className={style(styles.columnHeader(isMobile))}>{t('facility-type')}</span>
        </Row>
        <Column>
          <div className={style(styles.horizontalDivider)} />
          {sortedFacilityTypes.length === 0 ? (
            <span className={style(styles.emptyListMessage)}>{t('no-tags-available')}</span>
          ) : (
            <Grid
              rowClass={style(styles.gridRow)}
              itemSpacing={12}
              numberOfColumns={isMobile ? 1 : 3}
              numberOfItems={sortedFacilityTypes.length}
              renderItem={(index: number): React.JSX.Element => {
                const facilityType = sortedFacilityTypes[index];
                return (
                  facilityType && (
                    <div className={isMobile ? style(styles.rowItem(true)) : undefined} key={facilityType.facilityType}>
                      <FacilityTypeCard
                        isChecked={selectedFacilityType?.facilityType === facilityType.facilityType}
                        initialFacilityType={facilityType}
                        onClick={(value): void => {
                          handleFacilityTypeChanged(value);
                        }}
                      />
                    </div>
                  )
                );
              }}
            />
          )}
        </Column>
      </Column>
    </div>
  );
};

export default FacilityTypesGroup;
